// @ts-nocheck
/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gb2_assistantsalesorder_multimatch_description3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiple products match this position. Please select the correct one:`)
};

const en_us2_assistantsalesorder_multimatch_description3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiple products match this position. Please select the correct one:`)
};

const de_de2_assistantsalesorder_multimatch_description3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrere Artikel passen zu dieser Position. Bitte wählen Sie den korrekten aus:`)
};

const en_assistantsalesorder_multimatch_description3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multiple products match this position. Please select the correct one:`)
};

const de_assistantsalesorder_multimatch_description3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mehrere Artikel passen zu dieser Position. Bitte wählen Sie den korrekten aus:`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en-GB" | "en-US" | "de-DE" | "en" | "de" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
const assistantsalesorder_multimatch_description3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.assistantsalesorder_multimatch_description3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("assistantsalesorder_multimatch_description3", locale)
	if (locale === "en-GB") return en_gb2_assistantsalesorder_multimatch_description3(inputs)
	if (locale === "en-US") return en_us2_assistantsalesorder_multimatch_description3(inputs)
	if (locale === "de-DE") return de_de2_assistantsalesorder_multimatch_description3(inputs)
	if (locale === "en") return en_assistantsalesorder_multimatch_description3(inputs)
	return de_assistantsalesorder_multimatch_description3(inputs)
};
export { assistantsalesorder_multimatch_description3 as "assistantSalesOrder.multiMatch.description" }